exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container{max-width:800px;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-8b02f39e!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/examples/App.vue
// module id = 271
// module chunks = 0